// Shared status palette for the salud_timeline views (severity by lightness,
// colorblind-safe). State is always accompanied by a text label, never color alone.
// The app renders a light theme only; the dark variants come from the same contract
// and are kept here for when a dark mode exists:
//   HEALTHY #2E4630 · WATCH #A8721F · DEGRADED #FFB3AB · sin snapshot #232522

// strip codes: -1 sin snapshot · 0 HEALTHY · 1 WATCH · 2 DEGRADED
export const HEALTH_STATES = {
  '-1': { label: 'sin dato', color: '#ECECEA', text: '#666666' },
  0: { label: 'HEALTHY', color: '#CDE8CF', text: '#333333' },
  1: { label: 'WATCH', color: '#F0A13C', text: '#333333' },
  2: { label: 'DEGRADED', color: '#B3261E', text: '#FFFFFF' }
}

// resolves a strip code or a state name (as `transiciones` carries) to its entry
export const getHealthState = value => {
  if (HEALTH_STATES[value] !== undefined) return HEALTH_STATES[value]
  const byName = Object.values(HEALTH_STATES).find(
    state => state.label.toLowerCase() === String(value).trim().toLowerCase()
  )
  return byName || { label: String(value), color: '#ECECEA', text: '#666666' }
}
